import React, { useState, useEffect } from 'react';
import { X, Tag, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../context/SiteSettingsContext';

const SpecialOffersBanner = () => {
  const { settings } = useSiteSettings();
  const [isVisible, setIsVisible] = useState(true);
  const [currentOffer, setCurrentOffer] = useState(0);

  // Get settings with defaults
  const enabled = settings.showSpecialOffers !== false;
  const offers = (settings.specialOffers || [
    { text: "🎉 Winter Sale: 0% Financing on Select Vehicles!", link: "/apply-now", cta: "Learn More", enabled: true },
    { text: "🚗 Trade-In Bonus: Get $1,000 Extra for Your Trade!", link: "/contact", cta: "Get Quote", enabled: true },
    { text: "⭐ New Arrivals Weekly - Don't Miss Out!", link: "/inventory", cta: "View Inventory", enabled: true }
  ]).filter(o => o.enabled !== false);

  useEffect(() => {
    if (offers.length === 0) return;
    const interval = setInterval(() => {
      setCurrentOffer((prev) => (prev + 1) % offers.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [offers.length]);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('offerBannerDismissed');
    if (dismissed) setIsVisible(false);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem('offerBannerDismissed', 'true');
  };

  if (!isVisible || !enabled || offers.length === 0 || settings?.bannerEnabled) return null;

  const offer = offers[currentOffer];

  return (
    <div className="bg-gradient-to-r from-red-600 via-red-700 to-red-600 text-white py-2 px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.1) 10px, rgba(255,255,255,0.1) 20px)'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 relative">
        <Tag size={18} className="hidden sm:block animate-bounce" />
        
        <div className="flex items-center gap-3 text-sm md:text-base">
          <span className="font-medium">{offer.text}</span>
          <Link 
            to={offer.link}
            className="hidden sm:flex items-center gap-1 bg-white text-red-600 px-3 py-1 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors"
          >
            {offer.cta}
            <ArrowRight size={14} />
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-1 ml-4">
          {offers.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentOffer(idx)}
              className={`w-2 h-2 rounded-full transition-all ${idx === currentOffer ? 'bg-white w-4' : 'bg-white/50'}`}
            />
          ))}
        </div>

        <button onClick={handleDismiss} className="absolute right-2 md:right-4 p-1 hover:bg-white/20 rounded-full transition-colors">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SpecialOffersBanner;
